// 导出公用ip，打包时要改
// export const EXPORT_API = 'http://172.16.200.156:8088/apis/';  // jjj
// export const EXPORT_API = 'http://172.16.203.114:8002/apis/';  // whm
// export const EXPORT_API = 'http://10.2.58.221:8002/apis/';  // 测试服务器旧
// export const EXPORT_API = 'http://10.23.211.18:8088/apis/';  // 测试服务器新
export const EXPORT_API = 'http://gbms.gree.com/apis/';  // 正式服务器